import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=54acafaa&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=54acafaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acafaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54acafaa')) {
      api.createRecord('54acafaa', component.options)
    } else {
      api.reload('54acafaa', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=54acafaa&scoped=true", function () {
      api.rerender('54acafaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/CardItem.vue"
export default component.exports